<template>
  <span>
    <template v-if="noIcon !== true">
      <img v-if="providerIcon" :src="providerIcon" :alt="providerName" class="provider-icon" width="16" height="16">
      <v-icon v-else small class="provider-icon">mdi-help-circle</v-icon>
    </template>
    <span v-if="noName !== true">{{ providerName }}</span>
  </span>
</template>

<script>

import {LocaleUtils} from '@/utils/locale-utils';
import {BookingProviders} from '@/lib/booking-providers';

export default {
  name: 'BookingProvider',
  mixins: [
    LocaleUtils
  ],
  props: {
    value: {
      required: true
    },
    noIcon: {
      type: Boolean,
      default() { return false; }
    },
    noName: {
      type: Boolean,
      default() { return false; }
    }
  },
  computed: {
    provider () {
      for(const provider of BookingProviders) {
        if(provider.numericValue === this.value || provider.textValue === this.value) {
          return  provider;
        }
      }

      return null;
    },
    providerIcon() {
      if(this.provider && this.provider.numericValue != null && Number.isSafeInteger(this.provider.numericValue)) {
        return require('@/assets/providers/provider_' + this.provider.numericValue + '.png');
      }
      return null;
    },
    providerName() {
      if(this.provider && this.provider.textValue) {
        return this.trans('booking.providers.' + this.provider.textValue);
      }
      return this.trans('booking.providerUnknown');
    }
  },
}
</script>

<style>
.provider-icon {
  vertical-align: middle;
  margin-right: 4px;
  margin-bottom: 2px;
}
</style>
